/* eslint-disable @typescript-eslint/naming-convention */
import { Dispatch } from 'react';

import { LoanTerms } from '../common/types';

export interface DownPaymentState {
  downPayment: number;
  downPaymentPercent: number;
  interestRate: number;
  loanTerm: LoanTerms;
  showFull: boolean;
}

export enum DownPaymentDataActionsTypes {
  SET_DOWN_PAYMENT,
  SET_DOWN_PAYMENT_PERCENT,
  SET_INTEREST_RATE,
  SET_LOAN_TERM,
  SET_SHOW_FULL
}

export type DownPaymentDataActions =
  | {
      type: DownPaymentDataActionsTypes.SET_DOWN_PAYMENT;
      payload: DownPaymentState['downPayment'];
    }
  | {
      type: DownPaymentDataActionsTypes.SET_DOWN_PAYMENT_PERCENT;
      payload: DownPaymentState['downPaymentPercent'];
    }
  | {
      type: DownPaymentDataActionsTypes.SET_INTEREST_RATE;
      payload: DownPaymentState['interestRate'];
    }
  | {
      type: DownPaymentDataActionsTypes.SET_LOAN_TERM;
      payload: DownPaymentState['loanTerm'];
    }
  | {
      type: DownPaymentDataActionsTypes.SET_SHOW_FULL;
      payload: DownPaymentState['showFull'];
    };

export type DownPaymentContextType = {
  state: DownPaymentState;
  dispatch: Dispatch<DownPaymentDataActions>;
  getHomePrice: () => number;
  getMonthlyPayment: () => number;
};
